import React, { useState, forwardRef } from "react";
import { connect } from "react-redux";
import { fetch, setDadosPesq } from "../../actions";
import SelectBasico from "./SelectBasico";
import { LabelPadrao } from "../Base";
import useFiltros from "../Hooks/useFiltros";
import { useLayoutEffect } from "react";

const SelectFiltros = forwardRef((props, ref) => {
  const [dados, setDados] = useState([]);
  const [loading, modeloTratado] = useFiltros(props.fetch, props.modelo?.toLowerCase(), props.pesq, props.setDadosPesq, props.filtroId, props.tipo);
  const selected = `${modeloTratado}selected`;

  useLayoutEffect(() => {
    let aux = props.pesq[modeloTratado];
    if (!aux)
      return;

    setDados(aux);
    if (props.selectLast) {
      var val = props.pesq[selected];

      if (val > 0)
        onChange(val);

    }
    else if (modeloTratado == 'empresa' && aux.length === 1)
      onChange(aux[0].id);

  }, [props.pesq[modeloTratado]]);

  const onChange = e => {
    if (props.selectLast)
      props.setDadosPesq(selected, e);

    props.onChange(e);
  };

  return <div style={props.style}>
    {props.title && <LabelPadrao noMargin={props.noMargin}>{props.title}</LabelPadrao>}
    <SelectBasico
      placeholder={props.placeholder}
      multiNivel={!!dados?.find(x => !!x.filhos?.length)}
      disabled={props.disabled}
      dataCy={props.dataCy}
      dados={dados}
      value={props.value}
      onClear={() => props.setDadosPesq(selected, undefined)}
      onChange={onChange}
      loading={loading}
      mode={props.mode}
      allowClear={props.allowClear}
      {...props}
      ref={ref}
    />
  </div>;
});

const mapStateToProps = state => ({ pesq: state.pesq });

export default connect(mapStateToProps, { fetch, setDadosPesq }, null, { forwardRef: true })(SelectFiltros);